export default "__VITE_ASSET__04bf721a__"